export const SET_INFO = 'SET_INFO';
export const SET_LISTING = 'SET_LISTING';
